import * as React from "react";

import { useTranslate } from "../../hooks/useTranslate";
import { NewTabLink } from "../Link/NewTabLink";

import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";

export const UserAgreement: React.FunctionComponent<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslate();

  return (
    <DashboardTypography variant="caption" vibe="text-form-quiet">
      {t("donationForm", "userAgreement.thisSite")}
      <NewTabLink href="https://policies.google.com/privacy" display="inline">
        {t("donationForm", "userAgreement.privacyPolicy")}
      </NewTabLink>
      {t("donationForm", "userAgreement.and")}
      <NewTabLink href="https://policies.google.com/terms" display="inline">
        {t("donationForm", "userAgreement.termOfService")}
      </NewTabLink>
      {t("donationForm", "userAgreement.apply")}
      <NewTabLink href="https://support.zeffy.com/data-privacy-policy" display="inline">
        {t("donationForm", "userAgreement.privacyPolicy")}
      </NewTabLink>
      {t("donationForm", "userAgreement.end")}
    </DashboardTypography>
  );
};
